import React, { useState, useEffect, useContext } from 'react'
import { useDispatch, useSelector, ReactReduxContext } from 'react-redux'
import * as paymentStatementCopanActions from 'store/modules/paymentStatementCopan/actions'
import { DateTime } from 'luxon'
import get from 'lodash.get'
import { Container, Row, Col, Button, Spinner, Modal } from 'react-bootstrap'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import ptBR from 'date-fns/locale/pt-BR'
import { processDownload } from '../../../../helpers/download'
import MaskedInput from 'react-maskedinput'
import Typography from 'components/atoms/Typography'
import IconPDF from 'assets/img/icone-pdf.png'
import IconXLS from 'assets/img/icone-xls.png'
import IconXML from 'assets/img/icone-xml.png'
import IconXMLExchange from 'assets/img/icone-xml-exchange.png'
import 'react-datepicker/dist/react-datepicker.css'
import 'styles/datepicker.scss'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'styles/responsive-table.scss'
import './DemonstrativoPagamentoCopan.scss'
import CustomModal from 'components/molecules/CustomModal'
import { isDebugMode } from 'helpers/tools'

setDefaultLocale('pt-BR')
registerLocale('pt-BR', ptBR)

function DemonstrativoPagamentoCopan(props) {
  const { data, user } = props

  let login_user = useSelector((state) => state?.auth?.user)

  const dispatch = useDispatch()
  const { store } = useContext(ReactReduxContext)
  const reportLogs = useSelector((state) => state.paymentStatementCopan.reportLogs)
  const [displayLogs, setDisplayLogs] = useState([])
  const errorPaymentDemonstrativeCopan = useSelector(
    (state) => state.paymentStatementCopan.errorPaymentDemonstrativeCopan
  )  
  const breadcrumb = get(props, 'data.breadcrumb') || []
  const [requestDate, setRequestDate] = useState([])
  const [intervalId, setIntervalId] = useState(null)
  const [startDate, setStartDate] = useState(new Date())
  const [generatingNewDoc, setGeneratingNewDoc] = useState(false)
  const [loadingFile, setLoadingFile] = useState('')
  const [debugMode, setDebugMode] = useState(false)

  const token = useSelector((state) => state?.token)

  const [showError, setShowError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const [customInput, setCustomInput] = useState('')

  function checkExistingRequest(date) {
    if(!reportLogs?.logs) {
      return false
    } else {
      const logs = reportLogs?.logs["processing"].concat(reportLogs?.logs["success"]).concat(reportLogs?.logs["waiting"])
      return logs.filter((item)=>item.request_date.split(" ")[0]==date).length>0 
    }
  }

  function checkProcessingRequest() {    
    if(!reportLogs?.logs) {
      return false
    } else {
      const logs = reportLogs?.logs["processing"].concat(reportLogs?.logs["waiting"])
      return logs.length>0
    }
  }

  function checkRequestNoData(date) {    
    if(!reportLogs?.logs) {
      return false
    } else {
      const logs = reportLogs?.logs["errors"]
      return logs.filter((item)=> (item.request_date.split(" ")[0]==date && item?.response?.error.includes('No data found'))).length>0 
    }
  }

  // function checkNotReady(date) {    
  //   if(!reportLogs?.logs) {
  //     return false
  //   } else {
  //     const logs = reportLogs?.logs["errors"]
  //     return logs.filter((item)=> (item.request_date.split(" ")[0]==date && item?.response?.error.includes('not ready'))).length>0
  //   }
  // }

  const handleClose = () => {
    setShowError(false)
    setErrorMessage('')
  }
  const handleShow = () => setShowError(true)

  
  const generateDocs = (date) => {
    if (!date || typeof date !== 'object') {
      setErrorMessage('Data inválida.')
      handleShow()
      setStartDate(Date.now())
      return false
    }

    const dt = new Date(date).toISOString()

    setGeneratingNewDoc(true)

    const formattedDate = DateTime.fromISO(dt).toISODate()

    
    if(checkRequestNoData(formattedDate)){
      setErrorMessage('Nenhum dado encontrado para a data especificada.')
      handleShow()
      setGeneratingNewDoc(false)
      return false
    }
    if (!checkExistingRequest(formattedDate)) {
      setRequestDate([...requestDate, formattedDate])
      dispatch(
        paymentStatementCopanActions.generateDocsCopan({ date: formattedDate, uid: login_user?.contract, store, debugMode })
      )
          
    } else {
      setErrorMessage(<p>Já existe uma solicitação de Demonstrativo de Pagamento disponível para download referente a esta data.</p>)
      handleShow()
      setGeneratingNewDoc(false)
    }
  }  

  const renderTableItems = (items) => {    
    return items.map((item,index)=>{
      const dateRequested = get(item,'request_date')
      if (!dateRequested) return ''
      const pdfReport = get(item, 'response.pdf_report')
      const xlsReport = get(item, 'response.xls_report')
      const xmlReport = get(item, 'response.xml_report')
      const xmlReportExchange = get(item, 'response.xml_report_exchange')
      const hasDocument = get(item, 'response.total_time')
      const isError = get(item, 'response.error')
      const dateObj = dateRequested ? new Date(dateRequested) : null
      const date = DateTime.fromISO(dateObj.toISOString()).toFormat('dd/MM/yyyy')

      return (
        <Tr key={index}>
          <Td className="text-gray-100 payment-statement__report-status">
            {hasDocument ? (
              <div className="payment-statement__available"> Disponível </div>
            ) : (
              isError ? (<div className="payment-statement__loading">
                {isError.includes("Timeout") && (
                  <div className="payment-statement__error"> <i className="icone-alert mr-2" /> Erro</div>
                )}
                {isError.includes("No data") && (
                  <div className="payment-statement__nodata"> <i className="icone-alert mr-2" /> Sem dados</div>                  
                )}
                {isError.includes("not ready") && (
                  <div className="payment-statement__nodata"> <i className="icone-alert mr-2" /> Não baixado</div>                  
                )}
                {(!isError.includes("Timeout") && !isError.includes("No data") && !isError.includes("not ready")) && (
                  <div className="payment-statement__error"> <i className="icone-alert mr-2" /> Erro</div>                 
                )}
              </div>) : (<div className="payment-statement__loading">
                <Spinner animation="border" role="status" size="sm">
                  <span className="sr-only">Processando...</span>
                </Spinner>
                Processando
              </div>)              
            )}
          </Td>
          <Td className="text-gray-100 payment-statement__report-date">{date}</Td>
          <Td className={'text-gray-100'}>
            {isError && (isError.includes("Timeout") || isError.includes("not ready")) ? ( 
              <center>
                <Button              
                variant="outline-primary"
                size="sm"
                onClick={() => generateDocs(dateObj)}
                disabled={generatingNewDoc}>
                  Gerar novamente{' '}
                  {generatingNewDoc && <Spinner className="ml-2" animation="border" role="status" size="sm" />}
                </Button>
              </center>
            ) : (
              <div className={'payment-statement__report'}>
                {(!loadingFile || loadingFile != pdfReport) && (
                  <Button
                    className={`${pdfReport ? 'payment-statement__report--done' : ''}`}
                    title="Baixar relatório em PDF"
                    variant="link"
                    disabled={!pdfReport}
                    onClick={() => processDownload(token, `/api/v1/payment/file/${pdfReport}`, pdfReport, setLoadingFile)}
                  >
                    <img src={IconPDF} alt="ícone de representação de um arquivo PDF" />
                  </Button>
                )}
                {loadingFile != '' && loadingFile == pdfReport && (
                  <Spinner animation="border" size="sm" className="d-flex" />
                )}
                {(!loadingFile || loadingFile != xlsReport) && (
                  <Button
                    className={`${xlsReport ? 'payment-statement__report--done' : ''}`}
                    title="Baixar relatório em XLS"
                    variant="link"
                    disabled={!xlsReport}
                    onClick={() => processDownload(token, `/api/v1/payment/file/${xlsReport}`, xlsReport, setLoadingFile)}
                  >
                    <img src={IconXLS} alt="ícone de representação de um arquivo XLS" />
                  </Button>
                )}
                {loadingFile != '' && loadingFile == xlsReport && (
                  <Spinner animation="border" size="sm" className="d-flex" />
                )}
                {(!loadingFile || loadingFile != xmlReport) && (
                  <Button
                    className={''}
                    title="Baixar relatório em XML"
                    variant="link"
                    disabled={true}
                    onClick={() => processDownload(token, `/api/v1/payment/file/${xmlReport}`, xmlReport, setLoadingFile)}
                  >
                    <img src={IconXML} alt="ícone de representação de um arquivo XML" />
                  </Button>
                )}
                {loadingFile != '' && loadingFile == xmlReport && (
                  <Spinner animation="border" size="sm" className="d-flex" />
                )}
                {(!loadingFile || loadingFile != xmlReportExchange) && (
                  <Button
                    className={''}
                    title="Baixar relatório em XML Intercâmbio"
                    variant="link"
                    disabled={true}
                    onClick={() =>
                      processDownload(
                        token,
                        `/api/v1/payment/file/${xmlReportExchange}`,
                        xmlReportExchange,
                        setLoadingFile
                      )
                    }
                  >
                    <img src={IconXMLExchange} alt="ícone de representação de um arquivo XML" />
                  </Button>
                )}
                {loadingFile != '' && loadingFile == xmlReportExchange && (
                  <Spinner animation="border" size="sm" className="d-flex" />
                )}
              </div>
            )}            
          </Td>          
        </Tr>
      )
    }) 
  }

  useEffect(() => {
    if (errorPaymentDemonstrativeCopan) {
      setErrorMessage(errorPaymentDemonstrativeCopan)
      handleShow()
      setGeneratingNewDoc(false)
    }
  }, [errorPaymentDemonstrativeCopan])
  
  useEffect(() => {    
    dispatch(
      paymentStatementCopanActions.getReportLogs({ userCode: login_user?.contract, store, debugMode })
    )    
    const { host = '', search = '' } = window?.location || {}
    const isDebugModeTemp = isDebugMode({ host, search })
    setDebugMode(isDebugModeTemp)
  }, [])

  useEffect(() => {
    if(requestDate.length>0){
      for(const i in requestDate){
        // if(checkRequestNoData(requestDate[i])){
        //   setErrorMessage('Nenhum dado encontrado para a data especificada.')
        //   handleShow()
        // }
        // if(checkNotReady(requestDate[i])){
        //   setErrorMessage('Pagamento não baixado. Tente novamente mais tarde.')
        //   handleShow()
        // }        
        if(checkExistingRequest(requestDate[i])) {
          setGeneratingNewDoc(false)
        }
      }      
    }
    
    setGeneratingNewDoc(false)
    function checkStatusEveryNSeconds() {
      dispatch(
        paymentStatementCopanActions.getReportLogs({ userCode: login_user?.contract, store, debugMode })
      )
    }

    if (intervalId) {
      clearInterval(intervalId)
    }

    if(checkProcessingRequest()){
      const INTERVAL = 15000 // 15s
      setIntervalId(setInterval(checkStatusEveryNSeconds, INTERVAL))
    }

    if(reportLogs?.logs) {
      const logs = reportLogs.logs["processing"].concat(reportLogs.logs["waiting"]).concat(reportLogs.logs["success"]).concat(reportLogs.logs["errors"])
      setDisplayLogs(logs)
    }

    return function cleanup() {
      clearInterval(intervalId)
    }    
  }, [reportLogs])

  const handleDateChangeBlur = (e) => {
    setCustomInput('')
    if (e.target.value) {
      validateSelectedDay(e.target.value)
    }
  }

  const validateSelectedDay = (dateStr) => {
    let dateParts = dateStr.split('/')
    const date = new Date(dateParts[2], parseInt(dateParts[1]) - 1, dateParts[0])
    const result = DateTime.fromJSDate(date).toFormat('dd/MM/yyyy')
    if (dateStr != result) {
      setErrorMessage('Data inválida.')
      handleShow()
      setStartDate(new Date())
    } else {
      const currentDate = new Date()
      let d1 = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
      let d2 = DateTime.fromJSDate(currentDate).toFormat('yyyy-MM-dd')
      if (d1 > d2) {
        setErrorMessage('Data inválida, não é possível consultar uma data futura.')
        handleShow()
        setStartDate(new Date())
      }
    }
  }

  const handleFocus = () => {
    const maskedInput = <MaskedInput mask="11/11/1111" placeholder="dd/mm/yyyy" size="20" />
    setCustomInput(maskedInput)
  }

  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col>
          <Typography variant="h2" color="primary" cssClass="title-semibold-md payment-statement__title mb-3">
            {data.title}
          </Typography>

          <div className="bg-green-dark-100">
            <Typography variant="p" color="white" cssClass="p-2 uppercased">
              {login_user?.name}
            </Typography>
            <Typography variant="p" color="white" cssClass="p-2 uppercased payment-statement__code">
              Código Unimed: {login_user?.contract}
            </Typography>
          </div>

          <Typography id="date" cssClass="mb-3 mt-4" variant="p" color="gray-100">
            Informe uma data para a consulta e clique em Gerar para o formato desejado:
          </Typography>

          <DatePicker
            dateFormat="dd/MM/yyyy"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            maxDate={new Date()}
            onBlur={(e) => handleDateChangeBlur(e)}
            onClickOutside={(e) => handleDateChangeBlur(e)}
            onFocus={() => handleFocus()}
            customInput={customInput}
            title="Data"
            ariaLabelledBy="date"
          />

          <Button
            className="mt-4 mb-5"
            variant="outline-primary"
            size="lg"
            onClick={() => generateDocs(startDate)}
            disabled={generatingNewDoc}
          >
            Gerar documentos{' '}
            {generatingNewDoc && <Spinner className="ml-2" animation="border" role="status" size="sm" />}
          </Button>

          <CustomModal
            open={showError}
            closeModal={() => handleClose()}
            size="sm"
            title="Demonstrativo de Pagamentos"
            footer={{
              closeButton: true,
            }}
          >
            <p className="p-3">
              <strong>{errorMessage}</strong>
            </p>
          </CustomModal>
        </Col>
      </Row>

      {displayLogs.length > 0 && (
        <Row>
          <Col>
            <Table className="responsive-table payment-statement__process">
              <Thead>
                <Tr>
                  <Th>Status</Th>
                  <Th>Data</Th>
                  <Th className="text-center">Documentos</Th>
                </Tr>
              </Thead>
              <Tbody>{renderTableItems(displayLogs)}</Tbody>
            </Table>
          </Col>
        </Row>
      )} 
    </Container>
  )
}

export default DemonstrativoPagamentoCopan
